<template>
  <v-app>
    <v-snackbar
      color="red"
      v-model="$store.state.auth.networkErrorStatus"
      bottom
      right
      :timeout="3000"
    >
      <h3>Network Error</h3>
    </v-snackbar>
    <v-navigation-drawer
      temporary
      fixed
      enable-resize-watcher
      v-model="sideNav"
    >
      <v-list>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon color="indigo">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile>

        <v-list-group color="indigo" prepend-icon="account_circle" value="true">
          <template v-if="isLoggedIn" v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Users</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-group
            v-for="(menu, i) in getMenus"
            :key="i"
            no-action
            sub-group
            value="true"
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="(item, index) in menu.items"
              :key="index"
              :to="item.link"
            >
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon color="indigo">{{ item.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list-group>
      </v-list>
      <v-btn v-if="isLoggedIn" flat @click="logout">
        <v-icon color="indigo" left>lock</v-icon>
        Signout
      </v-btn>
    </v-navigation-drawer>

    <v-toolbar :clipped-left="clipped" color="indigo">
      <v-toolbar-side-icon
        @click.stop="sideNav = !sideNav"
        color="white"
      ></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon
          color="white"
          v-html="sideNav ? 'chevron_left' : 'chevron_right'"
        ></v-icon>
      </v-btn>
      <v-toolbar-title>
        <router-link
          color="white"
          to="/"
          tag="span"
          style="cursor: pointer; color: white"
        >
          Shadhin
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div
        v-for="(menu, i) in getMenus"
        :key="i"
        class="hidden-sm-and-down floating text-xs-center"
      >
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn flat v-on="on" color="white">
              <v-icon color="while">{{ menu.icon }}</v-icon>
              {{ menu.title }}
            </v-btn>
          </template>

          <v-list style="max-height: 400px" class="scroll-y">
            <template v-for="(item, index) in menu.items">
              <v-list-tile
                :key="index"
                v-if="item.external"
                :href="item.link"
                target="_blank"
              >
                <v-list-tile-title>
                  <v-icon left>{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :key="index" :to="item.link" v-else>
                <v-list-tile-title>
                  <v-icon left>{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list>
        </v-menu>
      </div>

      <shadhin-notifications v-if="isLoggedIn"></shadhin-notifications>

      <v-menu offset-y v-if="isLoggedIn">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="white" class="ml-4">
            <!-- <v-icon color="#555">person</v-icon> -->
            <h1 style="color: #666; font-size: 30px">
              {{ adminIcon }}
            </h1>
          </v-btn>
        </template>
        <v-list>
          <div class="pl-3 pr-2 pb-2">
            <h2>{{ adminName }}</h2>
            <h3>{{ adminEmail }}</h3>
          </div>
          <hr color="#999" />
          <v-list-tile to="/update-password">
            <v-list-tile-title>
              <v-icon class="mr-2">password</v-icon>
              Update Password
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>
              <v-icon class="mr-2">logout</v-icon>
              Logout
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <!-- <v-btn
        class="hidden-sm-and-down floating"
        color="white"
        v-if="isLoggedIn"
        flat
        @click="logout"
      >
        Signout
        <v-icon color="white" right>logout</v-icon>
      </v-btn> -->
      <!-- <v-toolbar-items class="hidden-sm-and-down floating">
        <v-btn flat v-for="item in getMenus" :key="item.title" :to="item.link">
          <v-icon left >{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
        <v-btn v-if="isLoggedIn" flat @click="logout" to="/">
          <v-icon left >lock</v-icon>
          Signout
        </v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <content>
      <router-view></router-view>
    </content>
    <!-- <v-footer :fixed="fixed"  >
      <span>&copy; 2019</span>
    </v-footer> -->
  </v-app>
</template>

<script>
  import { mapGetters, mapActions, mapState } from "vuex";
  import ShadhinNotifications from "./components/Notifications/Notifications.vue";

  export default {
    name: "App",

    components: {
      "shadhin-notifications": ShadhinNotifications,
    },

    data() {
      return {
        clipped: false,
        sideNav: false,
        fixed: false,
        VUE_APP_NEW_FRONTEND_URL: process.env.VUE_APP_NEW_FRONTEND_URL,
      };
    },

    computed: {
      ...mapGetters(["isLoggedIn", "getMenus"]),
      ...mapState(["application"]),
      ...mapState({
        adminName: (state) => state.auth.adminName,
        adminEmail: (state) => state.auth.adminEmail,
      }),
      adminIcon() {
        if (this.adminName) {
          let icon = this.adminName.split(" ");
          return icon[0][0];
        }
        return "A";
      },
    },
    methods: {
      ...mapActions(["login", "logout"]),
    },
  };
</script>

<style>
  .text-left {
    text-align: left;
  }

  .bgw {
    background-color: white;
  }

  .textUpper {
    text-transform: uppercase;
  }

  .tdNone {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
  }
</style>
